import { Link } from "react-router-dom";
import { DirectionBadge, LiveBadge } from "../components/Badges";
import { ErrorBanner } from "../components/ErrorBanner";
import { useApi } from "../hooks/useApi";
import { trainLabel } from "../api/format";
import type { Train } from "../api/types";

export function LiveBoard() {
  const { data, error, loading, retry } = useApi<Train[]>("/v1/trains?live=true");
  const rows = Array.isArray(data) ? data : [];

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Live board</h1>
          <p className="muted">Named passenger services from GetLiveTrains. This is not a map. is_live means GPS pinged recently.</p>
        </div>
      </div>
      <ErrorBanner error={error} onRetry={retry} />
      {loading ? <p className="muted">Loading live trains…</p> : null}
      {!loading && rows.length === 0 ? <p className="muted">No live passenger services right now.</p> : null}
      {rows.length > 0 ? (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Train</th>
                <th>Dir</th>
                <th>GPS ping</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((t) => (
                <tr key={t.train_id}>
                  <td>
                    <Link to={`/trains/${t.train_id}`}>{trainLabel(t)}</Link>
                  </td>
                  <td>
                    <DirectionBadge direction={t.direction} />
                  </td>
                  <td>
                    <LiveBadge live={Boolean(t.is_live)} />
                  </td>
                  <td>
                    <Link to={`/map/${t.train_id}`}>Track on map</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
